import gd_logo from './gd_logo.png';
import wsp_logo from './wsp_logo.png';
import bloodkin_logo from './bloodkin_logo.png';
import dac_logo from './dac_logo.png';
import dnc_logo from './dnc_logo.png';
import ms_logo from './ms_logo.png';
import nrps_logo from './nrps_logo.png';
import pg_logo from './pg_logo.png';
import holt_logo from './holt_logo.png';
import jc_logo from './jc_logo.png';
import bs_logo from './bs_logo.png';
import dbt_logo from './dbt_logo.png';
import hb_logo from './hb_logo.png';
import ls_logo from './ls_logo.png';
import mkb_logo from './mkb_logo.png';
import tort_logo from './tort_logo.png';
import kw_logo from './kw_logo.png';
import jj_logo from './jj_logo.png';
import zevon_logo from './zevon_logo.png';

// Every band is served by its own API instance on its own port (the port is a
// meaningful year for the band). `titleMatch` extracts the venue out of the
// archive.org item title. Whether Set Search is available for a band comes
// from the server (GET /ds/catalog/meta), not from this file. WSP data comes
// from panicstream rather than archive.org and has a different shape (see
// api.js adapters).
export const BANDS = [
  { key: 'dead',     name: 'Grateful Dead',                 port: 1965, logo: gd_logo,       titleMatch: 'Grateful Dead Live at (.*) on ' },
  { key: 'wsp',      name: 'Widespread Panic',              port: 1985, logo: wsp_logo,      wsp: true },
  { key: 'bs',       name: 'Billy Strings',                 port: 2013, logo: bs_logo,       titleMatch: 'Billy Strings Live at (.*) on ' },
  { key: 'bloodkin', name: 'Bloodkin',                      port: 1994, logo: bloodkin_logo, titleMatch: 'Bloodkin Live at (.*) on ' },
  { key: 'dac',      name: 'Dead & Company',                port: 2015, logo: dac_logo,      titleMatch: 'Dead & Company Live at (.*) on ' },
  { key: 'dbt',      name: 'Drive-By Truckers',             port: 1998, logo: dbt_logo,      titleMatch: 'Drive-By Truckers Live at (.*) on ' },
  { key: 'dnc',      name: 'Drivin N Cryin',                port: 1986, logo: dnc_logo,      titleMatch: 'Drivin n Cryin Live at (.*) on ' },
  { key: 'hb',       name: 'Hackensaw Boys',                port: 2000, logo: hb_logo,       titleMatch: 'Hackensaw Boys Live at (.*) on ' },
  { key: 'jj',       name: 'Jack Johnson',                  port: 2004, logo: jj_logo,       titleMatch: 'Jack Johnson at (.*) on ' },
  { key: 'jc',       name: 'Jupiter Coyote',                port: 1993, logo: jc_logo,       titleMatch: 'Jupiter Coyote Live at (.*) on ' },
  { key: 'kw',       name: 'Keller Williams',               port: 2003, logo: kw_logo,       titleMatch: 'Keller Williams at (.*) on ' },
  { key: 'ls',       name: 'Leftover Salmon',               port: 1991, logo: ls_logo,       titleMatch: 'Leftover Salmon Live at (.*) on ' },
  { key: 'mkb',      name: 'Marcus King Band',              port: 2014, logo: mkb_logo,      titleMatch: 'Marcus King Band Live at (.*) on ' },
  { key: 'ms',       name: 'Moonshine Still',               port: 2001, logo: ms_logo,       titleMatch: 'Moonshine Still Live at (.*) on ' },
  { key: 'nrps',     name: 'New Riders of the Purple Sage', port: 1969, logo: nrps_logo,     titleMatch: 'New Riders of the Purple Sage Live at (.*) on ' },
  { key: 'pg',       name: 'Perpetual Groove',              port: 2002, logo: pg_logo,       titleMatch: 'Perpetual Groove Live at (.*) on ' },
  { key: 'holt',     name: 'Sam Holt',                      port: 2007, logo: holt_logo,     titleMatch: 'Sam Holt Live at (.*) on ' },
  { key: 'tort',     name: 'Tortoise',                      port: 1992, logo: tort_logo,     titleMatch: 'Tortoise Live at (.*) on ' },
  { key: 'zevon',    name: 'Warren Zevon',                  port: 1976, logo: zevon_logo,    titleMatch: 'Warren Zevon Live at (.*) on ' },
];

export const bandByKey = (key) => BANDS.find((b) => b.key === key);
